import { TemplateItem } from "types";
import { generateAlignAttributes } from "./Position";
import { toServerAlignRatio } from "../../alignRatio";
import { AnimationEffectValue, Effects } from "../../../types";
import {
  getEffectDelayFrames,
  getEffectDurationFrames,
  getEffectMethod,
} from "../../animationHelpers";

type HorizontalAlign =
  | "left"
  | "right"
  | "none"
  | "outside_left"
  | "outside_right";
type VerticalAlign =
  | "top"
  | "bottom"
  | "none"
  | "outside_top"
  | "outside_bottom";

export const generateLeaveToAttribute = (
  effect: Effects,
  x: number,
  y: number,
  effectValue: AnimationEffectValue,
  width?: number,
  height?: number
): NonNullable<TemplateItem["attributes"]>[number] => {
  let horizontal: HorizontalAlign = "none";
  let vertical: VerticalAlign = "none";
  let horizontalRatio: number | null = null;
  let verticalRatio: number | null = null;

  // The cross-axis ratio is the item's resting position on that axis, so it
  // follows the same far-edge convention as a static position (see Position.ts).
  const hRatio = width !== undefined ? toServerAlignRatio(x, width) : x;
  const vRatio = height !== undefined ? toServerAlignRatio(y, height) : y;

  if (effect === Effects.leaveToTop) {
    vertical = "outside_top";
    horizontalRatio = hRatio;
  }

  if (effect === Effects.leaveToBottom) {
    vertical = "outside_bottom";
    horizontalRatio = hRatio;
  }

  if (effect === Effects.leaveToLeft) {
    horizontal = "outside_left";
    verticalRatio = vRatio;
  }

  if (effect === Effects.leaveToRight) {
    horizontal = "outside_right";
    verticalRatio = vRatio;
  }

  const duration = getEffectDurationFrames(effectValue);
  const method = getEffectMethod(effectValue);
  const startFrame = getEffectDelayFrames(effectValue, -duration);

  return {
    type: "Move",
    start: { type: "Frame", frame: startFrame },
    duration,
    from_position: generateAlignAttributes(x, y, width, height),
    to_position: {
      type: "Align",
      horizontal,
      vertical,
      horizontal_ratio: horizontalRatio,
      vertical_ratio: verticalRatio,
    },
    method,
  };
};
